module.exports = __webpack_public_path__ + "img/fuwuw.2ab4e2df.png";